export default (payload) => ({
  type: 'DELETE_LOAN_STATE',
  payload,
});
